var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacchina33Over(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "macchina-33-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "macchina-33-over"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,16.5 C33,25.6126574 25.6126906,33 16.5000741,33 C7.38730942,33 0,25.6126574 0,16.5 C0,7.38734261 7.38730942,0 16.5000741,0 C25.6126906,0 33,7.38734261 33,16.5",
    id: "Fill-1-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,24.3543391 C14.1470435,24.3543391 11.826087,22.0333826 11.826087,19.1804261 C11.826087,16.3274696 14.1470435,14.006513 17,14.006513 C19.8529565,14.006513 22.173913,16.3274696 22.173913,19.1804261 C22.173913,22.0333826 19.8529565,24.3543391 17,24.3543391 M17,12.1805594 C14.9493043,12.1805594 13.1073913,13.07229 11.826087,14.4820157 L11.826087,7 L10,7 L10,19.1737971 C10,19.1762319 10,19.178058 10,19.1804927 C10,23.0401951 13.1402609,26.1804261 17,26.1804261 C20.8597391,26.1804261 24,23.0401951 24,19.1804927 C24,15.3207903 20.8597391,12.1805594 17,12.1805594",
    id: "Page-1",
    fill: "#B99700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacchina33Over);
export default __webpack_public_path__ + "static/media/macchina-33-over.e5ca985d059310d4d9909d91e637bd1e.svg";
export { ForwardRef as ReactComponent };